import * as z from 'zod';

import { currencyInput } from '@/_schemas/generic';

import { vendorDetailsQuerySchema } from './inventory-query-schema';

export const vendorDetailsFormSchema = vendorDetailsQuerySchema.extend({
  vendor_sku: z.string(),
  vendor_url: z.string(),
  last_price: currencyInput.formSchema(),
  vendor_note: z.string(),
});

export type VendorDetailsFormSchema = z.infer<typeof vendorDetailsFormSchema>;
